import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawCommentingIcon from "./RawCommentingIcon.svg.jsx";

const CommentingIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawCommentingIcon} {...props} />;
});

export default CommentingIcon;
